import { render, staticRenderFns } from "./WheelchairAccessoriesForm.vue?vue&type=template&id=a7b6ba3e"
import script from "./WheelchairAccessoriesForm.vue?vue&type=script&lang=js"
export * from "./WheelchairAccessoriesForm.vue?vue&type=script&lang=js"
import style0 from "./WheelchairAccessoriesForm.vue?vue&type=style&index=0&id=a7b6ba3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports